define('v3/Common/Services/Backend/jwtTokenBackend',[
	'jquery',
	'./BackendBase'
], function ($, BackendBase) {
	function JwtTokenBackend () {
		BackendBase.call(this);
	};

	JwtTokenBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(JwtTokenBackend.prototype, {
		getImpersonateToken: function (accessToken) {
			return this._postJsonApi('Account/ImpersonateToken/', accessToken);
		}
	});
	return new JwtTokenBackend();
});

